import { esportaXLSX } from "../utils/esportaXLSX";
// src/pages/RegistroDDTPage.js
import React, { useState, useEffect } from "react";
import { collection, query, where, onSnapshot, doc, getDoc, setDoc, addDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useOrg } from "../contexts/OrgContext";
import { Plus, Search, FileText } from "lucide-react";
import DDTTab from "../components/DDTTab";

const STATI_DDT = {
  bozza:     { label: "Bozza",     bg: "#f3f4f6", col: "#6b7280" },
  emesso:    { label: "Emesso",    bg: "#d1fae5", col: "#065f46" },
  annullato: { label: "Annullato", bg: "#fee2e2", col: "#991b1b" },
};
const CAUSALI = ["Vendita","Conto lavorazione","Conto visione","Reso","Riparazione","Trasferimento","Comodato","Sostituzione","Consegna in cantiere","Altro"];

export default function RegistroDDTPage({ onNavigate }) {
  const { effectiveOrgId } = useOrg();
  const [tutti, setTutti] = useState([]);
  const [orgInfo, setOrgInfo] = useState(null);
  const [commesse, setCommesse] = useState([]);
  const [cerca, setCerca] = useState("");
  const [filtroStato, setFiltroStato] = useState("");
  const [filtroCausale, setFiltroCausale] = useState("");
  const [filtroDataDa, setFiltroDataDa] = useState("");
  const [filtroDataA, setFiltroDataA] = useState("");
  const [showNuovo, setShowNuovo] = useState(false);
  const [projectIdScelto, setProjectIdScelto] = useState("");
  const [confermato, setConfermato] = useState(false);
  const [editDDT, setEditDDT] = useState(null);

  useEffect(()=>{
    if(!effectiveOrgId) return;
    return onSnapshot(query(collection(db,"ddt"),where("orgId","==",effectiveOrgId)),
      snap=>setTutti(snap.docs.map(d=>({id:d.id,...d.data()}))
        .sort((a,b)=>{
          // bozze (senza numero) in cima, poi i DDT emessi dal numero più alto al più basso
          if(!a.numero!==!b.numero) return a.numero?1:-1;
          return (b.numero||"").localeCompare(a.numero||"") || (b.dataDocumento||"").localeCompare(a.dataDocumento||"");
        })));
  },[effectiveOrgId]);

  useEffect(()=>{
    if(!effectiveOrgId) return;
    getDoc(doc(db,"organizations",effectiveOrgId)).then(s=>{if(s.exists())setOrgInfo(s.data());});
    onSnapshot(query(collection(db,"projects"),where("organizationId","==",effectiveOrgId),where("archived","==",false),where("statoCommessa","==","attiva")),
      snap=>setCommesse(snap.docs.map(d=>({id:d.id,...d.data()})).filter(p=>!p.isParent&&!p.senzaCliente)));
  },[effectiveOrgId]);

  const filtrati=tutti.filter(d=>{
    if(filtroStato&&d.stato!==filtroStato) return false;
    if(filtroCausale&&d.causale!==filtroCausale) return false;
    if(filtroDataDa&&d.dataDocumento<filtroDataDa) return false;
    if(filtroDataA&&d.dataDocumento>filtroDataA) return false;
    if(cerca){
      const s=cerca.toLowerCase();
      return (d.numero||"").toLowerCase().includes(s)||(d.destinatarioNome||"").toLowerCase().includes(s)||(d.projectName||"").toLowerCase().includes(s)||(d.causale||"").toLowerCase().includes(s);
    }
    return true;
  });

  const progetto=commesse.find(c=>c.id===projectIdScelto);

  // Mostra selezione commessa prima di aprire il form
  if(showNuovo&&!confermato){
    const inp={padding:"8px 10px",border:"1px solid #e5e7eb",borderRadius:7,fontSize:13,fontFamily:"'Inter',sans-serif",outline:"none",width:"100%",boxSizing:"border-box"};
    return (
      <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
        <div style={{background:"#fff",borderBottom:"1px solid #e5e7eb",padding:"12px 24px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{fontSize:14,fontWeight:800,color:"#1e1b4b"}}>Nuovo DDT</div>
          <button onClick={()=>setShowNuovo(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#9ca3af"}}>×</button>
        </div>
        <div style={{padding:32,maxWidth:500}}>
          <p style={{fontSize:13,color:"#6b7280",marginBottom:20}}>Collega questo DDT a una commessa esistente (opzionale).</p>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:11,fontWeight:600,color:"#6b7280",display:"block",marginBottom:6}}>Commessa (opzionale)</label>
            <select style={inp} value={projectIdScelto} onChange={e=>setProjectIdScelto(e.target.value)}>
              <option value="">— Nessuna commessa —</option>
              {commesse.map(c=><option key={c.id} value={c.id}>{c.codiceCommessa?`[${c.codiceCommessa}] `:""}{c.name}</option>)}
            </select>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setConfermato(true)} style={{padding:"9px 20px",border:"none",borderRadius:8,background:"#1e1b4b",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              Continua →
            </button>
            <button onClick={()=>{setShowNuovo(false);setProjectIdScelto("");}} style={{padding:"9px 14px",border:"1px solid #e5e7eb",borderRadius:8,background:"#fff",fontSize:13,cursor:"pointer"}}>Annulla</button>
          </div>
        </div>
      </div>
    );
  }

  if(showNuovo&&confermato){
    return <DDTTab
      projectId={projectIdScelto||null}
      projectName={progetto?.name||""}
      codiceCommessa={progetto?.codiceCommessa||""}
      clienteNome={progetto?.clienteNome||""}
      clienteId={progetto?.clienteId||""}
      orgId={effectiveOrgId}
      nuovo
      onEsci={()=>{setShowNuovo(false);setConfermato(false);setProjectIdScelto("");}}
    />;
  }

  if(editDDT){
    const p=commesse.find(c=>c.id===editDDT.projectId);
    return <DDTTab
      projectId={editDDT.projectId||null}
      projectName={editDDT.projectName||p?.name||""}
      codiceCommessa={editDDT.codiceCommessa||p?.codiceCommessa||""}
      clienteNome={editDDT.clienteNome||p?.clienteNome||""}
      clienteId={editDDT.clienteId||""}
      orgId={effectiveOrgId}
      commessaChiusa={!!editDDT.projectId && !!p && p.statoCommessa==="chiusa"}
      apriDDT={editDDT}
      onEsci={()=>setEditDDT(null)}
    />;
  }

  const inp={padding:"6px 10px",border:"1px solid #e5e7eb",borderRadius:8,fontSize:12,fontFamily:"'Inter',sans-serif",outline:"none"};

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      <div style={{background:"#fff",borderBottom:"1px solid #e5e7eb",padding:"16px 24px",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:12}}>
          <h2 style={{fontSize:18,fontWeight:800,color:"#1e1b4b",margin:0,display:"flex",alignItems:"center",gap:8}}>
            <FileText size={20} color="#7c3aed"/> Registro DDT
          </h2>
          <span style={{fontSize:12,color:"#9ca3af"}}>{filtrati.length} documento/i</span>
            <button onClick={()=>{
              const intestazione=["Numero","Data","Commessa","Destinatario","Luogo di destinazione","Causale","Colli","Stato","Compilatore"];
              const righe=(filtrati||[]).map(d=>[ d.numero||"Bozza",d.dataDocumento?d.dataDocumento.split("-").reverse().join("/"):"—",(d.codiceCommessa?`[${d.codiceCommessa}] `:"")+(d.projectName||"—"),d.destinatarioNome||"—",d.destinazioneEffettiva||"—",(d.causale==="Altro"?d.causalePersonalizzata:d.causale)||"—",d.nColli||"—",(STATI_DDT[d.stato]||STATI_DDT.bozza).label,d.compilatoreNome||"—"]);
              esportaXLSX([intestazione,...righe],`Registro_DDT_${new Date().toLocaleDateString("it-IT").replace(/\//g,"-")}`,"DDT");
            }} style={{display:"flex",alignItems:"center",gap:5,padding:"6px 12px",border:"1px solid #059669",borderRadius:7,background:"#f0fdf4",color:"#059669",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📊 Excel
            </button>
          <button onClick={()=>{setShowNuovo(true);setConfermato(false);setProjectIdScelto("");}} className="btn btn-primary"
            style={{display:"flex",alignItems:"center",gap:5,padding:"5px 12px",fontSize:12}}>
            <Plus size={13}/> Nuovo DDT
          </button>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{position:"relative"}}>
            <Search size={13} style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)",color:"#9ca3af"}}/>
            <input value={cerca} onChange={e=>setCerca(e.target.value)} placeholder="Cerca numero, cliente, commessa..."
              style={{...inp,paddingLeft:26,width:220}}/>
          </div>
          <select value={filtroStato} onChange={e=>setFiltroStato(e.target.value)} style={inp}>
            <option value="">Tutti gli stati</option>
            {Object.entries(STATI_DDT).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
          </select>
          <select value={filtroCausale} onChange={e=>setFiltroCausale(e.target.value)} style={inp}>
            <option value="">Tutte le causali</option>
            {CAUSALI.map(c=><option key={c} value={c}>{c}</option>)}
          </select>
          <input type="date" value={filtroDataDa} onChange={e=>setFiltroDataDa(e.target.value)} style={inp} title="Da data"/>
          <input type="date" value={filtroDataA} onChange={e=>setFiltroDataA(e.target.value)} style={inp} title="A data"/>
          {(cerca||filtroStato||filtroCausale||filtroDataDa||filtroDataA)&&(
            <button onClick={()=>{setCerca("");setFiltroStato("");setFiltroCausale("");setFiltroDataDa("");setFiltroDataA("");}}
              style={{padding:"6px 12px",border:"1px solid #e5e7eb",borderRadius:8,background:"#fff",fontSize:12,cursor:"pointer"}}>
              × Reset
            </button>
          )}
        </div>
      </div>

      <div style={{flex:1,overflow:"auto"}}>
        {filtrati.length===0?(
          <div style={{textAlign:"center",padding:60,color:"#9ca3af"}}>
            <FileText size={48} style={{opacity:.15,marginBottom:12}}/>
            <div style={{fontSize:14,fontWeight:600}}>Nessun DDT trovato</div>
          </div>
        ):(
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead style={{position:"sticky",top:0,zIndex:5}}>
              <tr style={{background:"#1e1b4b"}}>
                {["N° DDT","Data","Destinatario","Commessa","Destinazione","Causale","Colli","Stato","Creato da"].map(h=>(
                  <th key={h} style={{padding:"9px 12px",textAlign:"left",color:"#fff",fontSize:10,fontWeight:700,whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrati.map((d,i)=>{
                const stato=STATI_DDT[d.stato]||STATI_DDT.bozza;
                return (
                  <tr key={d.id} onClick={()=>setEditDDT(d)}
                    style={{background:i%2===0?"#fff":"#fafafa",borderBottom:"1px solid #f3f4f6",cursor:"pointer"}}>
                    <td style={{padding:"9px 12px",fontFamily:"monospace",fontWeight:800,color:"#7c3aed",whiteSpace:"nowrap"}}>{d.numero||<span style={{fontFamily:"'Inter',sans-serif",fontWeight:600,color:"#9ca3af"}}>Bozza</span>}</td>
                    <td style={{padding:"9px 12px",whiteSpace:"nowrap",color:"#6b7280"}}>
                      {d.dataDocumento?new Date(d.dataDocumento+"T00:00:00").toLocaleDateString("it-IT"):"—"}
                    </td>
                    <td style={{padding:"9px 12px",fontWeight:600,color:"#111827"}}>{d.destinatarioNome||"—"}</td>
                    <td style={{padding:"9px 12px",color:"#7c3aed",fontFamily:"monospace",fontSize:11}}>
                      {d.codiceCommessa?`[${d.codiceCommessa}] `:""}{d.projectName||<span style={{color:"#d1d5db"}}>—</span>}
                    </td>
                    <td style={{padding:"9px 12px",color:"#6b7280",maxWidth:150,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.destinazioneEffettiva||"—"}</td>
                    <td style={{padding:"9px 12px",color:"#374151"}}>{d.causale||"—"}</td>
                    <td style={{padding:"9px 12px",textAlign:"center",fontWeight:700}}>{d.nColli||"—"}</td>
                    <td style={{padding:"9px 12px"}}>
                      <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,background:stato.bg,color:stato.col,fontWeight:700}}>{stato.label}</span>
                    </td>
                    <td style={{padding:"9px 12px",color:"#6b7280"}}>{d.compilatoreNome||"—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
